/**
 * @author NikolaV
 */
import { Ajax } from '@shared/Ajax';
import * as React from 'react';
import { Dialog } from '@shared/ui-react/Dialog';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { Tree } from '@shared/ui-react/Tree';


interface IModelsList {
    matchingModels: IModel[];
    nearByModels: IModel[];
    // calculated by service
    matchingModelIds?: number[];
    nearByModelIds?: number[];
}


export const NearbyModelsService = {
    fetch(lat, lon): JQueryPromise<IModelsList> {
        return Ajax({
            url: 'api/1/coords/modelsAtLocation.json',
            data: {
                lat,
                lon,
            },
        }).then(resp => {
            const matchingModelIds = resp.matchingModels.map(m => m.id);
            const nearByModelIds = resp.nearByModels.map(m => m.id);
            return {
                ...resp,
                matchingModelIds,
                nearByModelIds,
            };
        });
    },
};

export const NearbyModelsDialog = {
    open: (options: {
        models: IModelsList,
        treeData: ITreeData,
        onLoad: (ids: number[], includeLogpoints: boolean) => void
    }) => {
        const targetEl = document.getElementById('react-portal-root');

        if (!options.models.matchingModelIds.length && !options.models.nearByModelIds.length) {
            ReactUtils.safeRender(<Dialog onClose={NearbyModelsDialog.close}>
                <div className='padded text-center'>{kuura.getMessage('js_map.nearby_models.no_models')}</div>
            </Dialog>, targetEl);
        } else {
            ReactUtils.safeRender(<Dialog showHeader={false} onClose={NearbyModelsDialog.close}>
                    <NearbyModelsComponent
                        matchingModelIds={options.models.matchingModelIds}
                        nearbyModelId={options.models.nearByModelIds}
                        treeData={options.treeData}
                        onLoad={options.onLoad}
                        onClose={NearbyModelsDialog.close}/>
                </Dialog>, targetEl);
        }
    },

    close: () => {
        ReactUtils.safeUnmountComponentAtNode(document.getElementById('react-portal-root'));
    },
};


export class NearbyModelsComponent extends React.Component<{
    matchingModelIds: number[],
    nearbyModelId: number[],
    treeData: ITreeData,
    onLoad: (ids: number[], includeLogpoints: boolean) => void,
    onClose: () => void,
}> {
    checkedMatchingModels = this.props.matchingModelIds;
    checkedNearbyModels = this.props.matchingModelIds.length === 0 ? this.props.nearbyModelId : [];
    includeLogpointsInput: HTMLInputElement = null;

    style = {
        body: {
            backgroundColor: 'white',
        },
        topTree: {
            marginBottom: '2em',
            paddingBottom: '2em',
            borderBottom: '1px solid #e8e8e8',
            flexBasis: '50%',
            flex: 1,
            minHeight: '15vh'
        },
    };

    render() {
        if (!this.props.matchingModelIds.length && !this.props.nearbyModelId.length) {
            return <div className='padded text-center'>{kuura.getMessage('js_map.nearby_models.no_models')}</div>;
        }
        return (<>
                <div className='card padded flex-column of-h' style={this.style.body}>
                    {this.props.matchingModelIds.length > 0 && <div style={this.style.topTree} className='flex-column of-a'>
                        <h6>{kuura.getMessage('js_map.nearby_models.matching_models')}</h6>
                        <Tree treeData={this.props.treeData}
                              childFilter={c => {
                                  if (c.tolerance) return true;
                                  return this.props.matchingModelIds.includes(c.id);
                              }}
                              onChecked={node => {
                                  this.checkedMatchingModels = node.root?.getCheckedAndUncheckedFileIds().checkedIds;
                              }}
                              checkedIds={this.checkedMatchingModels}
                              expandOnStart={'all'}
                              includesFiles={true}
                              hideEmptyFoldersAlways={true}
                              hideEmptyFolders={true}/>
                        </div>
                    }
                    {this.props.nearbyModelId.length > 0 && <div className='flex-column of-a' style={{ flexBasis: '50%', flex: 1}}>
                        <h6>{kuura.getMessage('js_map.nearby_models.title')}</h6>
                        <Tree treeData={this.props.treeData}
                              childFilter={c => {
                                  if (c.tolerance) return true;
                                  return this.props.nearbyModelId.includes(c.id);
                              }}
                              checkedIds={this.checkedNearbyModels}
                              onChecked={node => {
                                  this.checkedNearbyModels = node.root?.getCheckedAndUncheckedFileIds().checkedIds;
                              }}
                              propagateCheckbox={'deep'}
                              expandOnStart={'all'}
                              includesFiles={true}
                              hideEmptyFoldersAlways={true}
                              hideEmptyFolders={true}/>
                        </div>
                    }
                    <hr/>
                    <label className='checkbox-label' style={{ flexShrink: 0 }}>
                        <input type='checkbox' ref={el => this.includeLogpointsInput = el}/> {kuura.getMessage('js_map.nearby_models.also_load_logpoints')}
                    </label>
                </div>

                <footer className='text-center padded' style={{ flexShrink: 0 }}>
                    <button onClick={this.props.onClose} style={{ marginRight: '1em' }}>{kuura.getMessage('general.close')}</button>
                    <button className='ik-button-primary' onClick={this.handleLoadModels}>{kuura.getMessage('js_map.nearby_models.load_selected_models')}</button>
                </footer>
            </>
        );
    }

    handleLoadModels = () => {
        this.props.onLoad([...this.checkedMatchingModels, ...this.checkedNearbyModels], this.includeLogpointsInput.checked);
    };
}

